import { Input, Modal } from 'antd';
import { green } from '@ant-design/colors';
import Loader from '../Loader';
import { CheckOutlined, CloseOutlined, XOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { apiV1 } from '../../utils/apiClient';
import { Promo } from '@next-is-free-monorepo/next-is-free-types';
import { z } from 'zod';
import { NButton } from '@next-is-free-monorepo/nif-web-components';

interface PromoCodeInputProps {
  onValid?: (promoPlan: Promo | undefined) => void,
  onConfirm: (promoPlan: Promo) => void,
}

const PromoCodeInput = ({ onValid, onConfirm }: PromoCodeInputProps) => {

  const [valid, setValid] = useState<boolean | undefined>(undefined);
  const [promoPlan, setPromoPlan] = useState<Promo | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const searchCode = useDebouncedCallback(async (text: string) => {
    setLoading(true);
    if(!text) {
      setValid(undefined);
      setPromoPlan(undefined);
      setLoading(false);
      return;
    }
    onValid && onValid(
      undefined
    )
    setPromoPlan(undefined);
    try {
      await z.string().min(4).parseAsync(text);
      const promo = await apiV1.get<Promo>('/promos/' + text);
      setPromoPlan(promo);
      setValid(true);
    } catch (e) {
      setValid(false);
    } finally {
      setLoading(false);
    }
  }, 500);

  return (
    <div className={'pt-3'}>
      <Input size={'large'} style={{ borderColor: valid ? green[5] : undefined }}
             onChange={(e) => searchCode(e.target.value)} placeholder={'Codice sconto'}
             suffix={loading ? <Loader /> : valid === false ? <CloseOutlined style={{ color: 'red' }} /> : valid ? <CheckOutlined style={{ color: green[6] }} /> : <div></div> }
      />
      {promoPlan &&
        <div className={'border p-3 rounded-lg mt-2 mb-4 bg-slate-900 text-white'}>
          <p className={'text-lg font-bold mb-2'} >
            {promoPlan.title_it}
          </p>
          <div className={'flex gap-1 text-xl'}>
            <p className={'text-slate-400 line-through'}>{promoPlan.old_price}</p>
            <p>{promoPlan.new_price}€</p><p className={'text-sm leading-8 text-slate-300'}>{promoPlan.price_time_range_it}</p>
          </div>
          <p className={'text-xs mt-2 text-slate-400'}>
            {promoPlan.disclaimer_it}
          </p>
        </div>
      }
      <div className={'flex justify-end mt-4'}>
        <NButton size={'small'} disabled={!valid} onClick={() => promoPlan && onConfirm(promoPlan)}>Continua</NButton>
      </div>
    </div>
  );
};
export default PromoCodeInput;
